import { LayerProperty } from 'cadenza/map/layer-property';
import i18n from 'cadenza/map/layer-actions/layer-actions.properties';

import { SelectFromOtherLayerDialog } from '../select-from-other-layer-dialog/select-from-other-layer-dialog';

import { LayerAction } from './layer-action';

export class SelectFromOtherLayer extends LayerAction {

  #map;

  constructor (layer, options) {
    super(layer, Object.assign({ label: i18n('selectionFromAnotherLayer.actionTitle') }, options));
    this.#map = options.map;
  }

  executeSync () {
    showSelectionfromAnotherLayerDialog(this.#map, this._layer.get(LayerProperty.ID));
  }

  isSupportedSync ({ isEditingLayer }) {
    return !isEditingLayer && this._layer.get(LayerProperty.HAS_FEATURES) && this._layer.get(LayerProperty.IS_INTERSECTABLE);
  }

}

function showSelectionfromAnotherLayerDialog (map, sourceLayerId) {
  const dialog = new SelectFromOtherLayerDialog(map, sourceLayerId);
  dialog.addEventListener('close', () => {
    dialog.remove();
  });
  document.body.appendChild(dialog);
  dialog.showModal();
}
